import { Controller } from '@hotwired/stimulus';

export default class PreventEnterSubmitController extends Controller {
  preventEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
